import "../sass/child-styles.scss";

// Child entry point intentionally minimal.
// Add customer-specific JS here when overriding parent behaviour.
